<template>
  <div class="login-box">
    <img class="img-bj" src="@/assets/img/images/login-bj.png" />
    <div class="login-form-box">
      <p class="p1">{{ $t("password_recovery.title1") }}</p>
      <template v-if="step === 1">
        <el-form v-loading="loading_step_1">
          <el-form-item :label="$t('password_recovery.account')" prop="name">
            <el-input
              v-model="account"
              :placeholder="$t('password_recovery.account_placeholder')"
            />
          </el-form-item>
          <div class="title-box">
            <div>
              {{ $t("password_recovery.tip2")
              }}<span @click="$router.push({ path: '/login' })">{{
                $t("password_recovery.btn_login")
              }}</span>
            </div>
          </div>
          <el-button class="login-btn" @click="sendAccount">下一步</el-button>
        </el-form>
      </template>

      <template v-if="step === 2">
        <el-form :model="formData" :rules="rules" ref="rulesResetPWD">
          <el-form-item
            :label="$t('password_recovery.password')"
            prop="password"
          >
            <el-input
              v-model="formData.password"
              :type="showPassword ? '' : 'password'"
              :placeholder="$t('tipsVal.inputPlaceholder')"
            >
              <template slot="suffix">
                <img
                  v-if="!showPassword"
                  @click="showPassword = !showPassword"
                  class="eye-img"
                  src="@/assets/img/images/icon/eye1.png"
                />
                <img
                  v-if="showPassword"
                  @click="showPassword = !showPassword"
                  class="eye-img"
                  src="@/assets/img/images/icon/eye2.png"
                />
              </template>
            </el-input>
          </el-form-item>
          <div class="tip-box">{{ $t("password_recovery.title3") }}</div>
          <el-form-item :label="$t('password_recovery.tip1')" prop="passwordConfirm">
            <el-input
              v-model="formData.passwordConfirm"
              :type="showPassword1 ? '' : 'password'"
              :placeholder="$t('tipsVal.inputPlaceholder')"
            >
              <template slot="suffix">
                <img
                  v-if="!showPassword1"
                  @click="showPassword1 = !showPassword1"
                  class="eye-img"
                  src="@/assets/img/images/icon/eye1.png"
                />
                <img
                  v-if="showPassword1"
                  @click="showPassword1 = !showPassword1"
                  class="eye-img"
                  src="@/assets/img/images/icon/eye2.png"
                />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('password_recovery.mes_code')"
            prop="phoneCode"
            v-if="phoneBind"
          >
            <el-input
              v-model="formData.phoneCode"
              maxlength="10"
              :placeholder="$t('password_recovery.code_placeholder')"
            >
              <template slot="append"
                ><span
                  v-if="!phoneCodeStatus.hasSend"
                  @click="hasSendPhoneCode"
                >
                  {{ $t("password_recovery.getCode") }}</span
                >
                <span v-else>{{ phoneCodeStatus.times }}</span></template
              >
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('password_recovery.email_code')"
            prop="emailCode"
            v-if="emailBind"
          >
            <el-input
              v-model="formData.emailCode"
              maxlength="10"
              :placeholder="$t('password_recovery.code_placeholder')"
            >
              <template slot="append">
                <span
                  v-if="!emailCodeStatus.hasSend"
                  @click="hasSendEmailCode"
                >
                  {{ $t("password_recovery.getCode") }}</span
                >
                <span v-else>{{
                  emailCodeStatus.times
                }}</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('password_recovery.google_code')"
            prop="googleCode"
            v-if="googleBind"
          >
            <el-input
              v-model="formData.googleCode"
              maxlength="10"
              :placeholder="$t('password_recovery.code_placeholder')"
            />
          </el-form-item>
          <el-button class="login-btn" @click="resetPassword">{{
            $t("password_recovery.submit")
          }}</el-button>
        </el-form>
      </template>
    </div>
  </div>
</template>

<script>
import bus from "@/assets/js/bus";
import { mapState } from "vuex";
export default {
  name: "login",
  data() {
    let passwordConfirmValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("validate.password_confirm_again")));
      } else if (value !== this.formData.password) {
        callback(new Error(this.$t("validate.password_confirm_error")));
      } else {
        callback();
      }
    };
    return {
      captchaObj: null,
      challenge: null,
      showPassword: false,
      showPassword1: false,
      loading_step_1: false,
      loading_step_2: false,
      loading_step_3: false,
      step: 1,
      account: "", //账号
      phone: "", //手机号
      email: "", //邮箱
      newPassword: "",
      passwordConfirm: "",
      phoneBind: false,
      emailBind: false,
      googleBind: false,
      formData: {
        emailCode: "", //邮箱验证码
        emailToken: "", //邮箱验证码token
        password: "",
        passwordConfirm: "",
        phoneCode: "",
        phoneToken: "", //手机验证码token
        googleCode: "", //google验证码
        vcToken: "", //第一步输入账号返回的token
      },
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },
      rules: {
        phoneCode: [
          {
            required: true,
            message: this.$t("validate.code_require"),
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            required: true,
            message: this.$t("validate.code_require"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("validate.password_require"),
            trigger: "blur",
          },
          {
            pattern: bus.regs.loginPWD,
            message: this.$t("validate.password_formatter_tip"),
            trigger: "blur",
          },
        ],
        passwordConfirm: [
          { validator: passwordConfirmValidate, trigger: "blur" },
        ],
        googleCode: [
          {
            required: true,
            message: this.$t("validate.google_code_require"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  mounted() {
    let this_vue = this;
    this.$axios
      .post("/geetest/startCaptcha?t=" + new Date().getTime())
      .then((res) => {
        let data = res.data;
        initGeetest(
          {
            gt: data.gt,
            challenge: data.challenge,
            offline: !data.success,
            new_captcha: true,
            product: "bind",
          },
          function (captchaObj) {
            this_vue.captchaObj = captchaObj;
            captchaObj
              .onReady(function () {
                // $("#wait").hide();
              })
              .onSuccess(function () {
                let result = captchaObj.getValidate();
                if (!result) {
                  this_vue.$message({
                    type: "error",
                    message: this_vue.$t("validate.geet_require"),
                  });
                } else {
                  this_vue.$axios
                    .post("/geetest/verifyLogin", {
                      challenge: data.challenge,
                      geetest_challenge: result.geetest_challenge,
                      geetest_validate: result.geetest_validate,
                      geetest_seccode: result.geetest_seccode,
                    })
                    .then((res) => {
                      this_vue.challenge = data.challenge;
                      this_vue.loading_step_1 = true;
                      this_vue.$axios
                        .post("/user/retrieveAccountVerify", {
                          username: this_vue.account,
                        })
                        .then((res) => {
                          if (res.data.code === this_vue.errorCode.ok) {
                            this_vue.phoneBind =
                              res.data.data.phoneSecurity === 1;
                            this_vue.emailBind =
                              res.data.data.emailSecurity === 1;
                            this_vue.googleBind =
                              res.data.data.googleSecurity === 1;
                            this_vue.formData.vcToken = res.data.data.vcToken;
                            this_vue.phone = res.data.data.phone;
                            this_vue.email = res.data.data.email;
                            this_vue.step = 2;
                          } else {
                            this_vue.$message({
                              type: "error",
                              message: res.data.msg,
                            });
                          }
                          this_vue.loading_step_1 = false;
                        });
                    });
                }
              });
          },
        );
      });
  },
  methods: {
    sendAccount() {
      //开启极验并发送账号获得用户绑定状况
      this.captchaObj.verify();
    },
    hasSendPhoneCode() {
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/user/sendRetrievePhoneCode", {
          phone: this.phone,
          challenge: this.challenge,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.formData.phoneToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    hasSendEmailCode() {
      this.emailCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus.times <= 0) {
          this.emailCodeStatus.hasSend = false;
          this.emailCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/user/sendRetrieveEmailCode", {
          email: this.email,
          challenge: this.challenge,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.formData.emailToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    resetPassword() {
      let ref = this.$refs.rulesResetPWD;
      ref.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.formData.challenge = this.challenge;
          this.$axios.post("/user/retrieve", this.formData).then((res) => {
            if (res.data.code === this.errorCode.ok) {
              window.localStorage.removeItem("jwt-token");
              this.elMessage("success", this.$t("password_recovery.success"));
              this.$store.dispatch("actions_loginOut").then((res) => {
                this.$router.push({ path: "/login" });
              });
            } else {
              this.elMessage("error", res.data.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-box {
  width: 100%;
  display: flex;
  position: relative;
  background: #f5f6f7;
  justify-content: center;
  height: calc(100% - 120px);
  .img-bj {
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    position: absolute;
  }
  .login-form-box {
    z-index: 2;
    width: 680px;
    margin-top: 60px;
    height: fit-content;
    position: relative;
    padding: 60px 88px;
    background: #ffffff;
    border-radius: 20px 20px 20px 20px;
    /deep/ .el-form {
      margin-top: 40px;
    }
    .p1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 40px;
      color: #333333;
    }
    .code-box {
      display: flex;
      gap: 16px;
    }
    .login-btn {
      background: #4063ff;
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      width: 100%;
      margin-top: 32px;
    }
    .title-box {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      span {
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #4063ff;
      }
    }
    /deep/.el-input-group--append {
      gap: 16px;
      display: flex;
    }
    /deep/.el-input-group__append {
      cursor: pointer;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #4063ff;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #4063ff;
      padding: 0 24px;
      width: auto;
      display: flex;
      align-items: center;
    }
    /deep/.is-checked .el-checkbox__inner {
      background: #4063ff;
    }
    /deep/.is-checked .el-checkbox__inner::after {
      width: 0;
      height: 0;
      border: none;
    }
    /deep/.el-input__inner {
      border-radius: 8px 8px 8px 8px;
    }
    /deep/.el-input-group__prepend {
      border-radius: 50%;
    }
    /deep/ .el-input__suffix,
    /deep/ .el-input__suffix-inner {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .eye-img {
      width: 25px;
      height: 25px;
      margin-right: 6px;
    }
    .tab-box {
      gap: 40px;
      display: flex;
      margin-top: 20px;
      margin-bottom: 10px;
      border-bottom: 1px solid #e2e3e3;
      div {
        padding-bottom: 20px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
      }
      .sel {
        font-weight: 800;
        font-size: 16px;
        color: #4063ff;
        position: relative;
      }
      .sel::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        bottom: 0;
        border-bottom: 1px solid #4063ff;
      }
    }
  }
}
</style>
